import { OnInit, AfterViewInit, HostListener, Output, EventEmitter, Directive } from '@angular/core';
@Directive({
    selector: '[infiniteScroll]',
})
export class InfiniteScrollDirective implements OnInit, AfterViewInit {
    @Output() scrolled = new EventEmitter();
    constructor(
    ) {
    }
    @HostListener('scroll', ['$event'])
    onScroll(event) {
        let scrollTop = event.target.clientHeight + event.target.scrollTop;
        if (event.target.scrollHeight === scrollTop) {
            this.scrolled.emit();
        }
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
    }
}

